import React from 'react';
import compose from 'lodash/fp/compose';
import {
  withTranslation,
  withDateFormat,
  withUserPreferences,
  withBankAccount,
  withCustomRouter,
} from 'components/hoc';
import MyDataContentTemplate from '../../common/MyDataContentTemplate';
import LottieLoader from 'components/common/LottieLoader';
import { isActive } from './utils';
import { useDispatch } from 'react-redux';
import { bankTransactionExtraction } from 'actions';


const renderIsActiveIcon = (valid_from, valid_to) => {
  return isActive(valid_from, valid_to) ? '\u2713' : '\u2717';
};


const maskAccountNumber = (accountNumber) => {
  if (!accountNumber) return '';
  
  // Always show 8 stars regardless of original length
  const stars = '********';
  // Always show last 3 digits if available
  const lastThreeDigits = accountNumber.length >= 3 
    ? accountNumber.slice(-3) 
    : accountNumber;
  
  return `${stars}${lastThreeDigits}`;
};

const Finance = (props) => {
  const filterableColumns = [
    {
      columnId: '_account_type',
      columnDataType: 'text',
    },
    {
      columnId: 'account_no',
      columnDataType: 'text',
    },
    {
      columnId: '_BIC',
      columnDataType: 'text',
    },
    {
      columnId: '_valid_from',
      columnDataType: 'date',
    },
    {
      columnId: '_valid_to',
      columnDataType: 'date',
    },
    {
      columnId: 'currency',
      columnDataType: 'text',
    },
    {
      columnId: '_access_type',
      columnDataType: 'text',
    },
    {
      columnId: 'organisation',
      columnDataType: 'text',
    },
    {
      columnId: '_account_ref',
      columnDataType: 'text',
    },
    {
      columnId: 'iban',
      columnDataType: 'text',
    },
    {
      columnId: 'is_active',
      columnDataType: 'text',
    },
    {
      columnId: 'IBAN',
      columnDataType: 'text',
    },
    {
      columnId: 'space_name',
      columnDataType: 'text',
    },
  ];

  const { deleteBulkBankAccount, bankAccounts, fd, trObj, gotoCreatePath, loaded } = props;

  const dispatch = useDispatch();
  // const { loading, transactions, error } = useSelector((state) => state.bankTransactionExtract);

  // extract transactions when user triggers the action
  const handleBankExtractionTransactions = (bankId) =>
    // Return the thunk's promise so the modal can await the result (TAN step).
    dispatch(bankTransactionExtraction(bankId));

  // Map the fields for displaying bank account data in the table
  const mapFields = () => {
    return bankAccounts.map((data) => ({
      ...data,
      space_name: data.space,
      is_active: renderIsActiveIcon(data.valid_from, data.valid_to),
      _valid_from: fd(data.valid_from),
      _valid_to: fd(data.valid_to),
      _access_type: trObj(data.account_access_type_detail),
      _account_type: trObj(data.account_type_detail),
      _account_ref: data.account_ref_detail?.account_no,
      account_no: maskAccountNumber(data?.account_no),
      _BIC: data.BIC_data?.BIC,
      organisation: (() => { const n = data.BIC_data?.org_name; return n && n.length > 25 ? `${n.substring(0, 25)}...` : n; })(),
    }));
  };

  if (!loaded) {
    return <LottieLoader />;
  }

  return (
    <React.Fragment>
      <MyDataContentTemplate
        tableName="bank_account"
        columns={[]}
        data={mapFields()}
        handleCreateForm={gotoCreatePath}
        bulkDelete={deleteBulkBankAccount}
        loadBankTransaction
        bankTransaction={handleBankExtractionTransactions}
        filterableColumns={filterableColumns}
      />
    </React.Fragment>
  );
};

export default compose(
  withTranslation,
  withDateFormat,
  withUserPreferences,
  withBankAccount,
  withCustomRouter,
)(Finance);

